import React, { useEffect } from 'react';
import BiometricsList from '../components/pages/Settings/BiometricsList';
import { connect } from 'react-redux';
import { getBiometricsList, updateBiometricName } from '../actions/profileActions';
import { IBiometricsContainer } from './types/BiometricsContainer';
import { AppDispatch, RootState } from '../store';
import { useNavigate } from 'react-router-dom';

const BiometricsContainer = ({ refreshBiometricList, biometrics, handleChangeName, rest }: IBiometricsContainer) => {
  // WYP-15357 - Hide Biometrics and depreciate the /biometrics page from the application
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard');
  }, [navigate]);

  useEffect(() => {
    refreshBiometricList();
  }, [refreshBiometricList]);

  return <BiometricsList biometrics={biometrics} handleChangeName={handleChangeName} {...rest} />;
};

const mapStateToProps = (state: RootState) => {
  return {
    biometrics: state.biometrics,
    myProfile: state.profile.profile.data,
    isFetching: state.fav.isFetching,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    refreshBiometricList: () => {
      dispatch(getBiometricsList());
    },
    handleChangeName: async (bioName: string, deviceId: string) => {
      const res = await dispatch(updateBiometricName(bioName, deviceId));

      setTimeout(() => dispatch(getBiometricsList()), 300);
      return res.status;
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BiometricsContainer);
